module.exports = __webpack_public_path__ + "img/special-you-icon2.1cf85889.png";